<template>
  <div class="border border-dark p-2 mb-2">
    <BaseTextFieldGroupWithProvider
      v-model="_value.name"
      empty-str-to-null
      :label="`項目名 - ${_value.displayOrder + 1}`"
      placeholder="空白にするとメンバーが自由に項目名を設定できます" />
    <MandalaGoalTemplateFormActivityGoalItem
      v-for="count in displayActionGoalsCount"
      :key="count"
      class="mb-2" />
  </div>
</template>

<script>
const minActionGoalsCount = 3
const maxActionGoalsCount = 8
import BaseTextFieldGroupWithProvider from '@/components/parts/BaseTextFieldGroupWithProvider.vue'
import MandalaGoalTemplateFormActivityGoalItem from './MandalaGoalTemplateFormActivityGoalItem.vue'
export default {
  components: {
    BaseTextFieldGroupWithProvider,
    MandalaGoalTemplateFormActivityGoalItem,
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    actionGoalsCount: {
      type: [String, Number],
      default: minActionGoalsCount
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v)
      }
    },
    displayActionGoalsCount() {
      const actionGoalsCount = +this.actionGoalsCount
      if (actionGoalsCount > maxActionGoalsCount) {
        return maxActionGoalsCount
      } else if (actionGoalsCount < minActionGoalsCount) {
        return minActionGoalsCount
      }
      return actionGoalsCount
    }
  }
}
</script>

<style>

</style>